export default __webpack_public_path__ + "static/krzysiu-3486948f42f839d585f3db2c228f7c38.png";